import { createFileRoute } from "@tanstack/react-router";

export { TicketDetailsPanel as TicketDrawerDetailsPanel } from "@/features/tickets/components/ticket-details-panel";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/_drawer/details",
)({
	/** Tab body is composed by the drawer layout into Figma `Details` (entity=ticket). */
	component: () => null,
});
